import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {UpdateBuyerTradeDataRequestTransactionsValueObject} from '../ValueObjects/UpdateBuyerTradeDataRequestTransactionsValueObject.js'

/**
 * @implements UseCase
 */
export class UpdateBuyerTradeDataTransactionsUseCase extends UseCase {
  constructor({httpTransactionsRepository}) {
    super()
    this._httpTransactionsRepository = httpTransactionsRepository
  }

  @inlineError
  async execute({address, city, lastName, name, personalId, phone, professionalActivityCode, tradeId, zipCode}) {
    const updateBuyerTradeDataRequestTransactionsValueObject =
      UpdateBuyerTradeDataRequestTransactionsValueObject.create({
        address,
        city,
        lastName,
        name,
        personalId,
        phone,
        professionalActivityCode,
        tradeId,
        zipCode
      })

    const [error] = await this._httpTransactionsRepository.updateBuyerTradeData(
      updateBuyerTradeDataRequestTransactionsValueObject
    )

    if (error) return Promise.reject(error)
  }
}
